import Component from 'flarum/common/Component';
export default class addMobileElement extends Component {
  oninit() {
    let lastPosition = 0;
    let touchingScreen = false;
    let scrollTimer = null;
    $(window).on('touchstart', e => {
      touchingScreen = true;
    });
    $(window).on('touchend', e => {
      touchingScreen = false;
      clearTimeout(scrollTimer);
      $(".mobilePinButton").css("bottom", "calc(70px + env(safe-area-inset-bottom))");
    });
    $(window).on('scroll', function (event) {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        if (touchingScreen === false) {
          $(".mobilePinButton").css("bottom", "calc(70px + env(safe-area-inset-bottom))");
        }
      }, 150);
      const position = $(this).scrollTop();
      if (position > lastPosition) {
        //down
      } else {
        //up
      }
      $(".mobilePinButton").css("bottom", "-50px");
      lastPosition = position;
    });
  }
  view() {
    var _app$current;
    const elementNewPostButton = $(".item-newDiscussion");
    const hasNewPostButton = elementNewPostButton.length > 0;
    const hidePin = !hasNewPostButton;
    const currentUserData = app.session.user;
    const isSuspended = currentUserData ? window.zivenCore.userIsSuspended(currentUserData) : false;
    const canStartDiscussion = app.forum.attribute('canStartDiscussion') || !app.session.user || isSuspended;

    // 2026-07-31 v0.4.7.1: 1.8 mithril Stream .get() → 2.0 PageState .data.routeName
    const routeName = String(((_app$current = app.current) == null || (_app$current = _app$current.data) == null ? void 0 : _app$current.routeName) || '');
    const hideTabRouteNameList = ["discussion", "discussion.near", "events", "search"];
    let hideTab = hideTabRouteNameList.indexOf(routeName) !== -1;
    return m("div", {
      style: hideTab ? "display:none;" : ""
    }, m("div", {
      className: "mobilePinButton",
      style: (!canStartDiscussion ? "background:var(--ziven-color-gray)" : "") + (hidePin ? "display:none;" : ""),
      onclick: () => {
        if (canStartDiscussion) {
          if (hasNewPostButton) {
            elementNewPostButton.find(".Button")[0].click();
          }
        }
      }
    }, m("i", {
      class: "fas fa-plus-circle"
    })));
  }
}
flarum.reg.add('ziiven-ziven-core', 'forum/components/addMobileElement', addMobileElement);